export const HELIOS_ANALYTICS_EVENT_TYPES = {
  HELIOS_ADD_TO_CART: 'heliosAddToCart',
  HELIOS_AD_TRACKING: 'heliosAdTracking',
  HELIOS_SORT_TRACKING: 'heliosSortTracking',
  HELIOS_FILTER_TRACKING: 'heliosFilterTracking',
  HELIOS_PRODUCT_CAROUSEL: 'heliosProductCarousel',
  HELIOS_BENTO_CARD: 'heliosBentoCard',
  HELIOS_PRODUCT_EVENT: 'heliosProductEvent',
  PRODUCT_CLICK: 'product_click',
  WAITING_ROOM_MODAL_VIEW: 'modal_view',
  HELIOS_NAV_CLICK: 'heliosNavClick',
  HELIOS_PAGE_TRACKING: 'heliosPageTracking',
  HELIOS_VERTICAL_FEATURE_CARDS: 'heliosVerticalFeatureCardContainer',
  HELIOS_HORIZONTAL_FEATURE_CARDS: 'heliosHorizontalFeatureCardContainer',
  HELIOS_BANNER_CAROUSEL: 'heliosBannerCarousel',
  HELIOS_REFRESH_LINKS_CLICK_TRACKING: 'refreshLinksClickTracking',
  HELIOS_PRODUCT_SEARCH_TRACKING: 'heliosProductSearchTracking',
  HELIOS_FORM_TRACKING: 'heliosFormTracking',
  HELIOS_ACQUISITION_FORM_SUBMIT: 'heliosAcquisitionFormSubmit',
  HELIOS_EXCEPTION_TRACKING: 'heliosExceptionTracking',
  HELIOS_BENTO_CARD_PRODUCT_CLICK: 'heliosBentoCardProductClick',
  HELIOS_BENTO_CARDS_CONTAINER_CTA: 'heliosBentoCardContainerCTA',
  HELIOS_BRAND_SPOTLIGHT_LOAD_VIEW: 'heliosBrandSpotlightLoadView',
  HELIOS_BRAND_SPOTLIGHT_PRODUCT_CLICK: 'heliosBrandSpotlightProductClick',
  HELIOS_BRAND_SPOTLIGHT_CTA: 'heliosBrandSpotlightCTA',
  HELIOS_CHIP_GROUP_CLICK: 'heliosChipGroupClick',
} as const;

export const SNOWPLOW = {
  PAGE_NAMES: {
    CATEGORY_PLP: 'category-plp',
    SUB_CATEGORY_PLP: 'sub-category',
    SUB_SUB_CATEGORY_PLP: 'sub-sub-category-plp',
    SEARCH_PLP: 'search-plp',
    HOME_LANDING_PAGE: 'shop-landing',
    BEAUTY_LANDING_PAGE: 'beauty|department-landing',
    PERSONAL_CARE_LANDING_PAGE: 'personal-care|department-landing',
    HEALTH_LANDING_PAGE: 'health|department-landing',
    ELECTRONICS_LANDING_PAGE: 'home-electronics|department-landing',
    BABY_AND_CHILD_LANDING_PAGE: 'baby-and-child|department-landing',
    WELLNESS_SHOP_PAGE: 'the-wellness-shop|department-landing',
    LUXURY_BEAUTY_PAGE: 'luxury-beauty|department-landing',
    CHECKOUT_PAGE: 'purchase',
    ORDER_CONFIRMATION_PAGE: 'order-confirmation',
    PREVIOUS_PURCHASE: 'previous-purchases',
    CONTACT_US: 'contact-us',
    SIGN_UP: 'sign-up',
    MY_SHOP_MOST_PURCHASED_PAGE: 'my-shop|most-purchased',
    MY_SHOP_FAVOURITES_PAGE: 'my-shop|favourites',
    MY_SHOP_DEALS_PAGE: 'my-shop|deals',
    MY_SHOP_CATEGORIES_PAGE: 'my-shop|categories',
  },
  PAGE_TEMPLATES: {
    DEPARTMENT_TEMPLATE: 'department-landing',
    PLP_TEMPLATE: 'plp',
    MY_SHOP_TEMPLATE: 'my-shop',
  },
  PAGE_PATH: {
    SEARCH: '/search',
    CATEGORIES: '/categories/',
    COLLECTIONS: '/collections/',
    CATEGORIES_ABBR: '/c/',
    PDP: '/p/',
    HEALTH: '/health/',
  },
  PLP_PAGE_PATH: {
    SEARCH: '/search',
    CATEGORIES: '/categories/',
    COLLECTIONS: '/collections/',
    CATEGORIES_ABBR: '/c/',
  },
  PAGE_SECTIONS: {
    LANDING: 'landing-page',
    CONTENT: 'content-page',
    SHOP: 'shop',
    HEALTH: 'health',
  },
  BEAUTY_SUBCATEGORIES: {
    MAKEUP: 'Makeup',
    SKINCARE: 'SkinCare',
    HAIRCARE: 'HairCare',
    TOOLS_AND_ACCESSORIES: 'ToolsAndAccessories',
    FASHION_AND_ACCESSORIES: 'fashion-and-accessories',
    FRAGRANCE: 'Fragrance',
  },
  EVENT_NAMES: {
    PRODUCT_CLEAR: 'product_clear',
    FILTER_SORT_CLEAR: 'filter_sort_clear',
    AD_CLEAR: 'ad_clear',
    COMPONENT_CLEAR: 'component_clear',
    UI_ENGAGEMENT: 'ui_engagement',
    UI_ENGAGEMENT_CLEAR: 'ui_engagement_clear',
    PRODUCT_PAGINATION_CLEAR: 'product_pagination_clear',
    PRODUCT_LISTING: 'product_listing',
    SEARCH_CLEAR: 'search_clear',
    FORM_SUBMIT: 'form_submit',
    MODAL_VIEW: 'modal_view',
    APPLY_FILTER: 'apply_filter',
  },
  ENV: {
    PROD: 'prod',
    DEV: 'dev',
    QA: 'qa',
  },
  APP_ID: {
    PROD: 'beauty-web-prod',
    DEV: 'beauty-web-dev',
    QA: 'beauty-web-qa',
  },
} as const;

export const PAGE_CMS = {
  CONTENTFUL_PAGE: 'contentful',
} as const;

export const MEDIA_PIXELS = {
  ADD_TO_BAG: 'add-to-bag',
  ADD_TO_BAG_OPEN: 'add-to-bag-open',
  CUSTOM_LINK: 'customLink',
} as const;

export const USER_CONTEXT = {
  REGISTRATION_STATUS: {
    UNKNOWN: 'unknown',
    REGISTERED: 'registered',
  },
} as const;

export const mockGlobalContextFields = {
  cartCount: 0,
  locale: 'en',
  currentDevice: '',
  pageId: '',
  pcOptimumAccount: {
    memberId: '',
    walletId: '',
    householdId: '',
    points: {
      balance: 0,
      dollarsRedeemable: 0,
      dollarsRedeemedLifetime: 0,
    },
  },
};

export const HELIOS_COMPONENT_NAMES = {
  PRODUCT_GRID_COMPONENT: 'productGridComponent',
};
